import { render, staticRenderFns } from "./OrderModalForm.vue?vue&type=template&id=37b1ee3e"
import script from "./OrderModalForm.vue?vue&type=script&lang=js"
export * from "./OrderModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports